import { Deck } from "../models/deck";
import { PurpleGemMaker } from "../cards/mine/purplegem";
import { RockMaker } from "../cards/mine/makeRock";
export class Mine extends Deck {
}
Mine.displayName = "Mine";
Mine.artUrl = "./assets/decks/mine.jpg";
// @ts-ignore
Mine.initialCards = [
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    RockMaker,
    PurpleGemMaker,
];
Mine.initialCardAddQueue = [];
Mine.initialCardsAllowed = new Set([RockMaker, PurpleGemMaker]);
Mine.defaultCardAdd = RockMaker;
